/*!
 *
 * swipe-elem.js
 *
 */

//var isTouchDevice = ('ontouchstart' in window);

$.SwipeElem = function( _this, _opt ){
	this.$target = $(_this);
	this.opt = $.extend({}, this.settings, _opt );
	this.init();
};

$.SwipeElem.prototype = {
	init: function(){
		this.build();
		this.event();
	},
	build: function(){
		this.$target.width( this.opt.width );
		this.$target.wrap('<div class="'+ this.opt.elemClass +'"><div class="'+ this.opt.elemClass +'-contents"></div></div>');
		this.$elem = this.$target.closest('.'+ this.opt.elemClass);
		this.$wrap = this.$target.closest('.'+ this.opt.elemClass + '-contents');
		this.$elem.prepend('<div class="'+ this.opt.elemClass +'-icon"></div>');
		this.$icon = this.$elem.children('.'+ this.opt.elemClass + '-icon');
		if( this.$target.is('.swipe-center') ){
			this.$icon.addClass('swipe-elem-icon-center');
		};
		this.$wrap.find('img').on('mousedown wrap', function(e){
			e.preventDefault();
		});
	},
	event: function(){
		var self = this,
			scrolling = false,
			timer = null;
		this.$wrap.on('scroll', function(){
			scrolling = true;
			self.$icon.fadeOut(100);
		});
	},
	settings: {
		width: 700,
		elemClass: 'swipe-elem'
	}
};

$.fn.swipeElem = function( options ){
	var _opt = options ? options : {};
	return this.each(function(){
		new $.SwipeElem( this, _opt );
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/swipe-elem.js
// module id = 20
// module chunks = 0